import { Badge } from '@mantine/core';
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
import {
	BADGE_INDICATOR_SIZE_STYLES,
	getBadgeIndicatorCssVars
} from './BadgeIndicator.constants';
import styles from './BadgeIndicator.module.css';
import {
	type BadgeIndicatorProps,
	BadgeIndicatorSize,
	BadgeIndicatorVariant
} from './types';

const BadgeIndicator = forwardRef<HTMLDivElement, BadgeIndicatorProps>(
	(
		{
			label,
			size = BadgeIndicatorSize.Small,
			theme,
			variant = BadgeIndicatorVariant.Soft
		},
		ref
	) => {
		return (
			<Badge
				className={cn(
					'relative isolate inline-flex shrink-0 overflow-visible rounded border-solid bg-[var(--ab-bg)] text-[var(--ab-fg)] font-semibold normal-case',
					variant === 'outline'
						? 'border border-[color:var(--ab-border)]'
						: 'border-0',
					styles.badgeGlow,
					BADGE_INDICATOR_SIZE_STYLES[size]
				)}
				data-badge-indicator-size={size}
				data-badge-indicator-theme={theme}
				data-testid="badge-indicator"
				radius="xs"
				ref={ref}
				style={getBadgeIndicatorCssVars(theme, variant)}
				styles={{
					label: {
						overflow: 'visible'
					}
				}}
				variant="default"
			>
				<span
					className="relative z-10"
					data-badge-indicator-variant={variant}
					data-testid="badge-indicator-label"
				>
					{label}
				</span>
			</Badge>
		);
	}
);

export { BadgeIndicator };
